import React, { useContext, createContext, ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import routerPaths from 'src/integration/config/routerPaths';
import { useStore } from 'src/integration/store/store';
import useFetchLogin from 'src/integration/api/useFetchLogin';


interface ComponentProps {
  children: ReactNode;
}

interface AuthContextType {
  user: Nullable<string>;
  token: Nullable<string>;
  loginAction: () => Promise<void>;
  logOut: () => void;
  loginError: Nullable<string>;
  isFetching: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const AuthProvider = ({ children }: ComponentProps) => {
  const [user] = useState<Nullable<string>>(null);
  const navigate = useNavigate();
  const { fetchLoginData, loginError, isFetching } = useFetchLogin();
  const { configStore } = useStore();
  const { jwtToken: token, removeJwtToken } = configStore;

  const loginAction = async () => {
    fetchLoginData();
  };

  const logOut = () => {
    removeJwtToken();
    navigate(routerPaths.login());
  };

  return (
    <AuthContext.Provider value={{ user, token, loginAction, logOut, loginError, isFetching }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};